import { Injectable, NgZone } from '@angular/core';
import { HttpContextToken, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export const SKIP_GLOBAL_LOADER = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoaderInterceptor  implements HttpInterceptor {
  requestCount:number=0
  private showTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(private loaderService: LoaderService, private ngZone: NgZone) {
  }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.context.get(SKIP_GLOBAL_LOADER)) {
      return next.handle(request);
    }

    this.requestCount++;
    // Delay show by 300ms so quick requests don't flash the progress bar
    if (!this.showTimer) {
      this.showTimer = setTimeout(() => {
        this.showTimer = null;
        if (this.requestCount > 0) {
          this.loaderService.show();
        }
      }, 300);
    }

    return next.handle(request).pipe(
          finalize(() => {
            this.requestCount--;
            if (this.requestCount <= 0) {
              this.requestCount = 0;
              if (this.showTimer) {
                clearTimeout(this.showTimer);
                this.showTimer = null;
              }
              this.ngZone.run(() => this.loaderService.hide());
            }
          }),
    );
 }
}